import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang,引入框架原有的语言包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang,引入框架原有的语言包
import enLocale from './en'
import zhLocale from './zh'

Vue.use(VueI18n)
//引入中英文对应文件
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}
//选择默认语言为中文，并将中英文对照放入
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get('language') || 'zh',
  
  // set locale messages
  messages
})
export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js